import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionStates } from '../../permission-controller/root';
import { RolePermStates } from '../states';
import { rolePermAdapters, RolePermState } from '../states/role-permissions.states';

export const rolePermFeatureKey = 'rolePerm';

export const selectRolePermFeature = createFeatureSelector<RolePermState>(rolePermFeatureKey);

export const selectEntity = (state: PermissionStates) => state.permissions.rolePerm.selectedEntity;

export const selectUpdateRoleListing = (state: PermissionStates) => state.permissions.rolePerm.updateRoleListing;
export const selectUpdateUserRoleListing = (state: PermissionStates) => state.permissions.rolePerm.updateUserRoleListing;
export const selectUpdateTeamRoleListing = (state: PermissionStates) => state.permissions.rolePerm.updateTeamRoleListing;
export const selectUpdateAllPermSetListing = (state: PermissionStates) => state.permissions.rolePerm.updateAllPermSetListing;
export const selectUpdateClientSideListing = (state: PermissionStates) => state.permissions.rolePerm.updateClientSideListing;

export const selectDetailsForm = (state: PermissionStates) => state.permissions.rolePerm.detailsForm;

export const selectGuid = (state: PermissionStates) => state.permissions.rolePerm.selectedGuid;
export const selectRequiresUpdate = (state: PermissionStates) => state.permissions.rolePerm.requiresUpdate;

export const selectRoleDetails = createSelector(
    selectDetailsForm,
    selectEntity,
    (form, entity) => ({form, entity})
)

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = rolePermAdapters.getSelectors(selectRolePermFeature);
